import React, { useRef, useEffect, useState } from 'react';
import './MapArea.css';
import MapPopup from '../elements/MapPopup';

import circle from '@turf/circle';

import limite_visivel from './limite_gaivotas.json';
import {open_popup,close_popup, show_sidebar, set_map_state, fetchAvistamento, fetchAtaque, fetchAninhamento} from '../redux/actions';
import {featureCollection, point} from '@turf/helpers';
import { useDispatch, useSelector } from 'react-redux';
import FilterButton from '../elements/FilterButton';
import ReactMapboxGl, {Image, Popup,Layer,  GeoJSONLayer, ZoomControl, RotationControl, Source} from "react-mapbox-gl";




const Map = ReactMapboxGl({
    accessToken: 'pk.eyJ1Ijoid2VuYXR1cmUiLCJhIjoiY2pxeG11ZXNzMDAyZDQ5bDZvcHB5ZHpyYiJ9.4guoNcUAFs4GX6XlYlhYBA'
  });





function MapArea() {

    
    const mapRef = useRef();
    const popup = useSelector(state => state.popup)
    const [baseMap, setBaseMap] = useState({baseButton: "Satélite", baseUrl: `mapbox://styles/mapbox/streets-v11?optimize=true}`});
    const [displayPoints, setDisplayPoints] = useState({loaded:false, data:{}});
    const filterState = useSelector(state => state.mapFilter);

    const handleBaseChange = () => {
        if(baseMap.baseButton === 'Satélite'){
            setBaseMap({baseButton: "Mapa", baseUrl: `mapbox://styles/mapbox/satellite-v9?optimize=true`})
        } else {
            setBaseMap({baseButton: "Satélite", baseUrl: `mapbox://styles/mapbox/streets-v11?optimize=true`});
        }
    }
    
    
    const showSidebar = useSelector(state => state.sidebar.show)
    const userLocation = useSelector(state => state.userLocation)
    const mapState = useSelector(state => state.mapState);
    const avistamentos_status = useSelector(state => state.avistamentos.statusGeral)
    const avistamentos_load = useSelector(state => state.avistamentos.avistamentos)
    const aninhamentos_status = useSelector(state => state.aninhamentos.statusGeral)
    const aninhamentos_load = useSelector(state => state.aninhamentos.aninhamentos)
    const ataques_status = useSelector(state => state.ataques.statusGeral)
    const ataques_load = useSelector(state => state.ataques.ataques)
    
    const dispatch = useDispatch();

    const filter_observacoes = (lista) => {
        let observacoes_filt = lista
        
        if(filterState.datas[0]){
            
            observacoes_filt = observacoes_filt.filter(ob => new Date(ob.properties.data) >= filterState.datas[0])
        }
        if(filterState.datas[1]){
          
            observacoes_filt = observacoes_filt.filter(ob => new Date(ob.properties.data) <= filterState.datas[1])
        }
        return observacoes_filt
    }
    useEffect(() => {
      
        if(avistamentos_status === 'LOADED' && aninhamentos_status === 'LOADED' && ataques_status === 'LOADED'){
          
        const avistamentos_filt = filter_observacoes(avistamentos_load);
            
        const avistamentos_disp = filterState.tipos.avistamentos ? avistamentos_filt.map(
        av => {
           
            return {...av, properties: {...av.properties, tipo: 'avistamento', icone:`avistamento_${av.properties.validado}`, id:av._id}
        }
    }
        ): [];

        const aninhamentos_filt = filter_observacoes(aninhamentos_load);

        const aninhamentos_disp = filterState.tipos.aninhamentos ?  aninhamentos_filt.map(
        an => (
            {...an, properties: {...an.properties, tipo: 'aninhamento', icone:`aninhamento_${an.properties.validado}`, id:an._id}
        }
        )
        ): [];
        
        const ataques_filt = filter_observacoes(ataques_load);

        const ataques_disp = filterState.tipos.ataques ? ataques_filt.map(
        at => (
            {...at, properties: {...at.properties, tipo:`ataque`, icone:`ataque_${at.properties.validado}`, id:at._id}}
        )
        ) : [];

        const display = [...aninhamentos_disp, ...avistamentos_disp, ...ataques_disp]
    
        setDisplayPoints({loaded:true, data:featureCollection(display)})
        
    }
      }, [avistamentos_status, avistamentos_load, aninhamentos_status, aninhamentos_load, ataques_status, ataques_load, filterState])
  
    // const mapState = useSelector(state => state.mapState);

    function handleLocationUpdate(e){
       
        if(!mapRef.current.state.map.isMoving()){
            
            dispatch({type: 'UPDATE_LOCATION', payload: {hasLocation: true, location: [e.coords.latitude, e.coords.longitude], accuracy: e.coords.accuracy, error: false}})
        }
        
        
    }

    function handleLocationError(e){
        dispatch({type: 'LOCATION_ERROR'})
    }

    useEffect(() => {
        const location_watch = navigator.geolocation.watchPosition(
                    (e) => {if([e.coords.latitude, e.coords.longitude]!==userLocation.location ){handleLocationUpdate(e)}},
                    () => handleLocationError()
                )
        return () => {if(navigator.geolocation){
                        navigator.geolocation.clearWatch(location_watch);
                    }}
    }, [])
 
    function handleViewportUpdate(map){
        
        
        
        const coords = map.getCenter();
        const zoom = map.getZoom();
        
        
        dispatch(set_map_state({latitude:coords.lat, longitude:coords.lng, zoom:zoom}))
 
    }
     
    function onHoverStart(){
       
        
        mapRef.current.state.map.getCanvas().style.cursor = 'pointer'
    }

    function onHoverEnd(){
        mapRef.current.state.map.getCanvas().style.cursor = 'grab'
    }
    const handleMarkerClick = (map) => {
        
        const point = mapRef.current.state.map.queryRenderedFeatures(map.point).filter(point => point.layer.id ==="unclustered_layer")[0]
        const point_data = {...point.properties}
       
        if(point_data.tipo==='avistamento'){
            dispatch(fetchAvistamento(point_data.id))
        }else if(point_data.tipo==='aninhamento'){
            dispatch(fetchAninhamento(point_data.id))
        }else if(point_data.tipo==='ataque'){
            dispatch(fetchAtaque(point_data.id))
        }
       
        dispatch(
            open_popup(
                {
                    position:[map.lngLat.lng, map.lngLat.lat],
                    tipo:point_data.tipo
                }
                )
                )
       
        
    }
 
    return(
        <div>
            
            <Map
                ref={mapRef}
                containerStyle={{
                position:'absolute',
                width: "100%",
                height: "100%",
                
                }
                }
                
                onMouseDown={()=>dispatch(close_popup())}
                onMoveEnd={handleViewportUpdate}
                
                
                
                zoom={[mapState.zoom]}
                center={[mapState.longitude, mapState.latitude]}
                // renderChildrenInPortal={true}
                style={baseMap.baseUrl}
                >
                     
                    {popup.show ? <Popup
                            offset={[0, -10]}
                            // anchor='bottom'
                            coordinates={[popup.position[0], popup.position[1]]}
                            closeOnClick={true}
                            onClose={ () => dispatch(close_popup())}>
                                                <MapPopup/>
                                            </Popup>:null}
                <GeoJSONLayer
                    key={1}
                    data={limite_visivel}
                    fillPaint={{"fill-color": 'grey', "fill-opacity":0.6}}
                    linePaint={{"line-color":'grey'}}
                />
                <Image id='aninhamento_true' url={'/app/nest.png'} options={{'icon-size':0.5}}/>
                <Image id='aninhamento_false' url={'/app/nest_nvalidado.png'} options={{'icon-size':0.5}}/>
                <Image id='ataque_true' url={'/app/ataque.png'} options={{'icon-size':0.5}}/>
                <Image id='ataque_false' url={'/app/ataque_nvalidado.png'} options={{'icon-size':0.5}}/>
                <Image id='avistamento_true' url={'/app/gull.png'} options={{'icon-size':0.5}}/>
                <Image id='avistamento_false' url={'/app/gull_nvalidado.png'} options={{'icon-size':0.5}}/>
                    <GeoJSONLayer
                        id='observations_geojson'
                        data = {displayPoints.data}
                        
                        sourceOptions={{
                            cluster: true,
                            clusterMaxZoom: 14,
                            clusterRadius: 50
                          }}
                        
                          
                    />
                        <Layer
                            id='cluster_layer'
                            sourceId='observations_geojson'
                            filter={
                                [
                                'has', 'point_count'
                                ]
                            }
                            paint={{
                                'circle-color': '#0DAFD0',
                                'circle-opacity': 0.6,
                                'circle-radius': 30
                            }}
                            type='circle'
                            onClick={(evt) => dispatch(set_map_state({latitude:evt.lngLat.lat, longitude:evt.lngLat.lng, zoom:mapState.zoom + 2}))}
                            onMouseEnter = {onHoverStart}
                            onMouseLeave = {onHoverEnd}
                        />
                        <Layer
                            id='cluster_label'
                            sourceId='observations_geojson'
                            filter={
                                [
                                'has', 'point_count'
                                ]
                            }
                            
                            layout={{
                                "text-field": "{point_count}",
                                "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                                "text-size": 16,
                                
                              }}
                              paint= {{
                                "text-color": "#ffffff"
                              }}
                              
                        />
                        
                        <Layer
                            id='unclustered_layer'
                            sourceId='observations_geojson'
                            layerOptions={{
                                filter: [
                                '!has', 'point_count'
                                ]
                            }}
                            layout = {{"icon-image":["get", "icone"], "icon-size":0.5}}
                            onMouseEnter = {onHoverStart}
                            onMouseLeave = {onHoverEnd}
                            onClick={(map, evt) => handleMarkerClick(map, evt)}
                            // symbolClick = {(map, evt)=>handleMarkerClick(map, evt)}
                            
                        >

                                {/* <Feature coordinates={[-8.74304,41.36056]} onClick={(map, evt) => handleMarkerClick(map, evt)}/> */}
                            </Layer>
                            
                            
                            
                           
                    
                {popup.show ? <Popup
                offset={[0, -10]}
                // anchor='bottom'
                coordinates={[popup.position[0], popup.position[1]]}
                closeOnClick={true}
                onClose={ () => dispatch(close_popup())}>
                                    <MapPopup/>
                                </Popup>:null}
                <ZoomControl position='top-right' style={{marginTop:'35px'}}/>
                <RotationControl position='top-right' style={{marginTop:'40px'}}/>
                
            {userLocation.hasLocation?<>
            
            {/* <Marker
                key={900}
                coordinates={[userLocation.location[1], userLocation.location[0]]}
                anchor="center">
                <div style={{ width:'8px', height:'8px', borderRadius:'50%', border: '2px solid darkblue', backgroundColor: 'blue', zIndex:-10}}></div>
            
            </Marker> */}
            <Source id="user_loc_source" geoJsonSource={{type:'geojson', data:point([userLocation.location[1], userLocation.location[0]])}} />
            <Layer
            id='user_loc'
            sourceId='user_loc_source'
            
            paint={{
                'circle-color': 'blue',
                "circle-stroke-width": 1,
                "circle-stroke-color": 'darkblue',
                'circle-radius': 5
            }}
            type='circle'
            
            
        />

            <GeoJSONLayer
                key={1000}
                data={circle([userLocation.location[1], userLocation.location[0]],userLocation.accuracy, {steps: 50, units: 'meters'} )}
                fillPaint={{"fill-color": "blue", "fill-opacity":0.2}}
                />
            </>: null}
            
        
            </Map>
            {!showSidebar?<div
                onClick={() => dispatch(show_sidebar())}
                
                style =  {
                    {
                    width:'64px',
                    height:'48px',
                    position: 'absolute',
                    cursor:'pointer',
                    left: '10px',
                    top: '10px',
                    zIndex:'1700',
                    display: 'flex',
                    flexDirection:'column',
                    fontWeight:'bold',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#F7F9F9',
                    borderRadius: '2px',
                    boxShadow: 'rgb(0 0 0 / 75%) 2px 2px 3px 0px'
                    }
                    }
                    >
                    
                    <div style={{display:'flex', justifyContent:'space-around'}}><img src='/app/house.png' alt="" style={{width:'30px', height:'30px'}}/></div>
                    <div style={{fontSize:'0.8em', display:'flex', justifyContent:'space-around'}}>Menu</div>
                            
            </div>:null}
            <div
                    onClick={() => {
                        if(userLocation.hasLocation){
                           
                            dispatch(set_map_state({latitude:userLocation.location[0], longitude:userLocation.location[1], zoom:18}))
                        }
                            }
                    }
                    style = {
                        {
                        position:'absolute',
                        top:'138px',
                        right:'11px',
                        width:'26px',
                        height:'26px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#F7F9F9',
                        borderRadius: '2px',
                        cursor: 'pointer'
                        
                        // WebkitBoxShadow: !sidebarShowing ?"2px 2px 3px 0px rgba(0,0,0,0.75)":null,
                        // MozBoxShadow: !sidebarShowing ?"2px 2px 3px 0px rgba(0,0,0,0.75)":null,
                        // boxShadow: !sidebarShowing ?"2px 2px 3px 0px rgba(0,0,0,0.75)":null
                        }
                        }
                        >
                        
                        {userLocation.hasLocation ? <div style={{ width:'8px', height:'8px', borderRadius:'50%', border: '2px solid darkblue', backgroundColor: 'blue'}}></div> : <div style={{width:'8px', height:'8px', borderRadius:'50%', border: '2px solid darkgrey', backgroundColor: 'grey'}}></div>}
                            
                        
                    </div>
                    <div
                        onClick={handleBaseChange}
                        
                        style = {
                            {
                            position:'absolute',
                            top:'10px',
                            right:'10px',
                            width:'60px',
                            height:'26px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#F7F9F9',
                            borderRadius: '2px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            fontSize:12,
                            WebkitBoxShadow: "2px 2px 3px 0px rgba(0,0,0,0.75)",
                            MozBoxShadow: "2px 2px 3px 0px rgba(0,0,0,0.75)",
                            boxShadow: "2px 2px 3px 0px rgba(0,0,0,0.75)",
                            WebkitTapHighlightColor: 'rgba(51, 181, 229, 0.4)'
                            }
                            }
                            >
                            
                                {baseMap.baseButton}
                            
                        </div>
                        <FilterButton />
                        {/* {deletingState !== 'WAITING' ? <ConfirmationModal tipo='delete' />:null} */}
                        {/* {validatingState !== 'WAITING' ? <ConfirmationModal tipo='validate' />:null} */}
        </div>
        
    )

}

export default MapArea;